export const categoryConst ={
    
    ADD_CATEGORY: 'ADD_CATEGORY_REQUEST',
    ADD_CATEGORY_SUCCESS: 'ADD_CATEGORY_SUCCESS',
    ADD_CATEGORY_FAILURE: 'ADD_CATEGORY_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/categoryConst.js